import { render, staticRenderFns } from "./AtcRequirementPendingArea.vue?vue&type=template&id=23003859&"
import script from "./AtcRequirementPendingArea.vue?vue&type=script&lang=js&"
export * from "./AtcRequirementPendingArea.vue?vue&type=script&lang=js&"
import style0 from "./AtcRequirementPendingArea.vue?vue&type=style&index=0&id=23003859&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports